import style from './RewardLeaderBoard.module.css'
import tether_green from '/tether-green.png'
import tether_white from '../../../../public/dreamcoin-logo.svg'
// Предполагаю, что у вас есть вторая иконка

// Константа с данными о наградах
const REWARDS_DATA = [
  { place: '1', amount: 20, icon: 'green', symbol: 'USDT' },
  { place: '2', amount: 10, icon: 'green', symbol: 'USDT' },
  { place: '3', amount: 5, icon: 'green', symbol: 'USDT' },
  { place: '4-10', amount: 3, icon: 'green', symbol: 'USDT' },
  { place: '11-20', amount: 1, icon: 'green', symbol: 'USDT' },
  { place: '21-100', amount: 1000, icon: 'white', symbol: 'DC' },
]

export default function RewardLeaderBoard() {
    const getIcon = (iconType) => {
        return iconType === 'green' ? tether_green : tether_white;
    }

    return (
        <div className={style['rewards-container']}>
            <div className={style['rewards-title']}>
                <span>Награды:</span>
            </div>
            <div className={style['rewards-list']}>
                {REWARDS_DATA.map((reward, index) => (
                    <div className={style['reward-item']} key={index}>
                        <span className={style['reward-item-text-place']}>{reward.place} место:</span>
                        <div className={style['reward-image']} data-icon={reward.icon}>
                            <img src={getIcon(reward.icon)} alt="USDT" />
                        </div>
                        <span className={style['reward-item-text-amount']}><span className={style['reward-item-text-amount-number']}>{reward.amount}</span> {reward.symbol}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}